var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-button',{staticClass:"p-0",style:(_vm.styles),attrs:{"size":"sm","btn-style":"white"}},[_c('i',{staticClass:"fs-16",class:_vm.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }